/**
 * Local Storage
 * Provide a failsafe hook to set, get and remove local storage items
 * @param  {String} action    Action to do with the localStorage (get/set/remove)
 * @param  {String} item      The localStorage's target key
 * @param  {String} value     The value to add to the localStorage (set only)
 * @return {String}           Return the localStorage Data (get only)
 */

const useLocalStorage = (action, item, value) => {
  const isBrowser = typeof window !== 'undefined'
  let storageSupported = false
  try {
    storageSupported = (isBrowser && window.localStorage) && true
  } catch (e) { }

  if (!storageSupported || !item || item === null) {
    return ''
  }

  let localData = null
  {
    action === 'get' && (
      localData = localStorage.getItem(item)
    )
  }
  {
    action === 'set' && (
      localData = localStorage.setItem(item, (value ? value : undefined))
    )
  }
  {
    action === 'remove' && (
      localData = localStorage.removeItem(item)
    )
  }

  return localData
}
export default useLocalStorage